import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["Field", "id", "type", "onChange", "onFocus", "onBlur", "onEnter", "children", "value", "placeholder", "emptyPlaceholder", "mappedFields", "error", "onBulkEdit", "onBulkCancel", "isBulk", "bulkEditLabel", "bulkCancelLabel"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { InputWrapper, Text, Link, createUseStyles, useTheme } from '@Sage/hoi-poi-ui';
import styles from "./styles/fieldControl";
const useStyles = createUseStyles(styles, 'ForceForm-FieldControl');
function FieldControl(_ref) {
  let {
      Field,
      id,
      type,
      onChange,
      onFocus,
      onBlur,
      onEnter,
      children,
      value,
      placeholder,
      emptyPlaceholder,
      mappedFields,
      error,
      onBulkEdit,
      onBulkCancel,
      isBulk,
      bulkEditLabel,
      bulkCancelLabel
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const classes = useStyles();
  const [bulkMode, setBulkMode] = useState(isBulk && type !== 'Section');
  const onChangeField = useCallback(input => {
    const value = input && input.target ? input.target.value : input;
    onChange && onChange(value, id, type, mappedFields);
  }, [id, onChange, type, mappedFields]);
  const theme = useTheme();
  const onFocusField = useCallback(input => {
    const value = input && input.target ? input.target.value : input;
    onFocus && onFocus(value, id, type);
  }, [id, onFocus, type]);
  const onBlurField = useCallback(input => {
    const value = input && input.target ? input.target.value : input;
    onBlur && onBlur(value, id, type, mappedFields);
  }, [id, onBlur, type, mappedFields]);
  const onEnterField = useCallback(input => {
    const value = input && input.target ? input.target.value : input;
    onEnter && onEnter(value, id, type);
  }, [id, onEnter, type]);
  const toggleBulk = useCallback(() => {
    bulkMode ? onBulkEdit === null || onBulkEdit === void 0 ? void 0 : onBulkEdit(id, type) : onBulkCancel === null || onBulkCancel === void 0 ? void 0 : onBulkCancel(id);
    setBulkMode(!bulkMode);
  }, [bulkMode, id, onBulkCancel, onBulkEdit, type]);
  if (!Field) return null;
  const fieldProps = _objectSpread({
    onEnter: onEnterField,
    onChange: onChangeField,
    onFocus: onFocusField,
    onBlur: onBlurField,
    placeholder: !value || Array.isArray(value) && !value.length ? emptyPlaceholder || placeholder : placeholder,
    value,
    error: !bulkMode ? error : undefined
  }, props);
  if (bulkMode) {
    return /*#__PURE__*/React.createElement(InputWrapper, _extends({
      id: id,
      labelMode: "horizontal"
    }, props), /*#__PURE__*/React.createElement(Text, {
      className: classes.bulkText,
      onClick: toggleBulk,
      color: theme.colors.grey[200]
    }, bulkEditLabel));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, _extends({
    id: id
  }, fieldProps), children), isBulk && type !== 'Section' && /*#__PURE__*/React.createElement(Link, {
    className: classes.cancelBtn,
    type: "caption",
    onClick: toggleBulk
  }, bulkCancelLabel));
}
process.env.NODE_ENV !== "production" ? FieldControl.propTypes = {
  placeholder: PropTypes.string,
  emptyPlaceholder: PropTypes.string,
  value: PropTypes.any,
  error: PropTypes.any,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onEnter: PropTypes.func,
  Field: PropTypes.any
} : void 0;
export default /*#__PURE__*/React.memo(FieldControl);